/* Collection "Choose collection" pills (sections/main-collection-product-grid.liquid).
   Pills are real links to /collections/<handle>; with JS they re-render the
   section body in place via the Section Rendering API and update the URL, so
   facets.js (which builds its URLs from window.location.pathname) keeps
   working on the newly selected collection. */
if (!customElements.get('collection-switcher')) {
  class CollectionSwitcher extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.abortController = null;
      this.renderedPath = window.location.pathname;
      this.onClick = this.onClick.bind(this);
      this.onPopState = this.onPopState.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopState);
    }

    onClick(event) {
      const pill = event.target.closest('[data-collection-pill]');
      if (!pill || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      const url = new URL(pill.href, window.location.origin);
      if (url.pathname === this.renderedPath && !window.location.search) return;

      this.setActivePill(url.pathname);
      this.render(url, true);
    }

    onPopState() {
      if (window.location.pathname === this.renderedPath) return;
      this.render(new URL(window.location.href), false);
    }

    setActivePill(pathname) {
      this.querySelectorAll('[data-collection-pill]').forEach((pill) => {
        const isActive = new URL(pill.href, window.location.origin).pathname === pathname;
        pill.classList.toggle('is-active', isActive);
        if (isActive) {
          pill.setAttribute('aria-current', 'page');
        } else {
          pill.removeAttribute('aria-current');
        }
      });
    }

    async render(url, pushState) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.querySelector('#ProductGridContainer .collection')?.classList.add('loading');

      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.sectionId);

      try {
        const response = await fetch(fetchUrl, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('collection-switcher');
        if (!source) throw new Error('Missing collection-switcher in section response');

        this.innerHTML = source.innerHTML;
        this.renderedPath = url.pathname;
        if (pushState) history.pushState({ collectionSwitcher: true }, '', `${url.pathname}${url.search}`);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url.href;
      }
    }
  }

  customElements.define('collection-switcher', CollectionSwitcher);
}
